import * as request from '@/utils/request'
import * as querystring from 'querystring'
// import {
// 	formatTime
// } from '../../utils/utils.js'
export function factoryArray(field, selector = 'data') {
	return function(state, json) {
		// 没有参数检测，请确保arguments可用
		if (json && json.list) {
			state[field] = [...state[field], ...json.list]
		} else {
			state[field] = [...state[field], ...json[selector].list]
		}
	}
}

export function set(field, value = '', selector = 'data') {
	console.log(field, value, "这里")
	return function(state, json) {
		if (value) {
			state[field] = value
		} else {
			state[field] = json[selector]
		}
		// state[field] = arg.value ? arg.value : json[arg.selector]
	}
}

/**
 * 动态生成vuex async action(结合服务器api设计更改
 * @param {string} requestUrlTemplate 请求字符串 "/api/albums/:id/course/:courseId"
 * @param {string} method 请求类型
 */
export function makeAsyncAction(requestUrlTemplate, COMMIT_TYPE, name = 'get') {	
	/* http 请求类型 */
	const method = getMethod(name)	
	//**console.log('method', method);
	// 调用时传入的各种参数类型
	return async function({
		commit,
		rootState,
		state
	}, payload) {		
		const url = getUrl(requestUrlTemplate, payload)		
		/* http 请求 */
		const json = await method(url, payload)
		if (COMMIT_TYPE) commit(COMMIT_TYPE, json)
		return json
	}
}

/*
 * 防误操作
 */
export function makeForbidAsyncAction(requestUrlTemplate, COMMIT_TYPE, name = 'get') {
	/* http 请求类型 */
	const method = getMethod(name)
	// 调用时传入的各种参数类型
	return async function({
		commit,
		rootState,
		state
	}, payload) {
		const url = getUrl(requestUrlTemplate, payload)
		if (rootState.isProcessing) return Promise.reject('');
		try {
			// commit('SET_PROCESSING', true)
			const json = await method(url, payload)
			// commit('SET_PROCESSING', false)
			if (COMMIT_TYPE) commit(COMMIT_TYPE, json)
			return json
		} catch (e) {
			// commit('SET_PROCESSING', false)
			return Promise.reject(e)
		}
	}
}


export function makeAsyncRestfulAction(requestUrlTemplate, COMMIT_TYPE, name = 'get') {
	/* http 请求类型 */
	const method = getMethod(name)
	// 调用时传入的各种参数类型
	return async function({
		commit,
		rootState,
		state
	}, payload) {
		let url = getUrl(requestUrlTemplate, payload)
		let {
			model
		} = payload
		//**console.log('querystirng', querystring,payload)
		/* http 请求 */
		if (name === 'get') {
			url = `${url}?${querystring.stringify(payload)}`
		}
		// //**console.log('makeAsyncRestfulAction', url, payload)
		commit('fetching', true)
		const json = await method(url, payload)
		//**console.log('makeAsyncRestfulAction json', json, 'url', url)
		commit('fetching', false)
		if (COMMIT_TYPE) commit(COMMIT_TYPE, {
			model,
			data: json.data || json
		})
		return Promise.resolve(json)
	}
}


export function makeAsyncRequest(defaultUrl, COMMIT_TYPE, name = 'get') {
	/* http 请求类型 */
	// 调用时传入的各种参数类型
	return async function({
		commit,
		rootState,
		state
	}, payload) {
		const {
			method,
			url,
			...params
		} = payload;
		const request = getMethod(method || name)
		commit('fetching', true)
		const json = await request(url || defaultUrl, params)
		//**console.log('makeAsyncRequest json', request, json, 'url', url)
		commit('fetching', false)
		if (COMMIT_TYPE) commit(COMMIT_TYPE, {
			data: json.data
		})
		return Promise.resolve(json)
	}
}

/**
 * 方法判断
 */
export function getMethod(name = 'get') {
	if (name === 'delete') {
		return request['del']
	} else {
		// console.log('=================>',name)
		return request[name] || request['get']
	}
}

export function getUrl(requestUrlTemplate, payload) {
	return requestUrlTemplate.replace(/(:(.+?)(\/|$))/g, function(match, p1, p2, p3) {		
		const value = payload[p2]
		if (!value) throw new Error(`payload中找不到与${p2}对应的值`)
		const ret = [value, p3].join('')
		delete payload[p2]
		return ret
	})
}
